
<div class="page">

    <div class="page-header">
        <div class="breadcrumb">
            <p-breadcrumb [model]="breadcrumbs" [home]="homeBreadcrumb"></p-breadcrumb>
        </div>
        <div class="search">
            <input pInputText type="text" (input)="filter(dt, $event)" placeholder="Search..." />           
        </div>
        <div class="actions">
            <button pButton pRipple label="New" icon="pi pi-plus" class="button-action p-button-success p-mr-2" (click)="openNew()"></button>
            <button pButton pRipple label="Delete" icon="pi pi-trash" class="button-action p-button-danger" (click)="deleteSelectedRecipes()" [disabled]="!selectedRecipes || !selectedRecipes.length "></button>
        </div> 
    </div>

    <div class="page-content">
        <p-table #dt 
            [value]="recipes"                                                                                                      
            [rows]="10" 
            [paginator]="true" 
            [globalFilterFields]="['name','description','status']"
            [rowsPerPageOptions]="[5,10,25,50,100]"
            [(selection)]="selectedRecipes" 
            [resizableColumns]="true"
            [reorderableColumns]="true"
            [rowHover]="true" 
            dataKey="$key"
            styleClass="p-datatable-striped"
            currentPageReportTemplate="{first} to {last} of {totalRecords}" 
            [showCurrentPageReport]="true"
            selectionMode="multiple"
            [columns]="selectedColumns"
            >

            <ng-template pTemplate="colgroup">
                <colgroup>
                    <col style="max-width:10%">
                    <col style="max-width:20%">
                    <col style="min-width:10%;max-width:80%">
                    <col style="max-width:20%">
                </colgroup>
            </ng-template>
            
            <ng-template pTemplate="caption">
                <p-multiSelect 
                    [options]="cols" 
                    [(ngModel)]="selectedColumns" 
                    optionLabel="header"
                    selectedItemsLabel="{0} columns selected" 
                    [style]="{minWidth: '200px'}" 
                    placeholder="Choose Columns">
                </p-multiSelect>
            </ng-template>


            <ng-template pTemplate="header" let-columns="columns">
                <tr>
                    <th pResizableColumn pSortableColumn="position" style="width: 8rem">
                        Order<p-sortIcon field="position"></p-sortIcon>
                    </th>
                    <th id="name" name="name" pResizableColumn pReorderableColumn pSortableColumn="name" [class]="includesCol('name') ? 'd' : 'h'">Name 
                        <p-sortIcon field="name"></p-sortIcon> 
                        <p-columnFilter type="text" field="name" display="menu"></p-columnFilter>
                    </th>
                    <th id="description" name="description" pResizableColumn pReorderableColumn [class]="includesCol('description') ? 'd' : 'h'">Description</th>
                    <th id="inputs" name="inputs" pResizableColumn pReorderableColumn [class]="includesCol('inputs') ? 'd' : 'h'">Inputs</th>
                    <th id="outputs" name="outputs" pResizableColumn pReorderableColumn [class]="includesCol('outputs') ? 'd' : 'h'">Outputs</th>
                    
                    <!-- <th pSortableColumn="price">Price <p-sortIcon field="price"></p-sortIcon></th>
                    <th pSortableColumn="category">Category <p-sortIcon field="category"></p-sortIcon></th>
                    <th pSortableColumn="rating">Reviews <p-sortIcon field="rating"></p-sortIcon></th>
                    <th pSortableColumn="inventoryStatus">Status <p-sortIcon field="inventoryStatus"></p-sortIcon></th> -->
                    <th pResizableColumn pReorderableColumn style="width: 8rem">
                        Actions 
                        <!-- <button type="button" pButton pRipple icon="pi pi-file-o" (click)="dt.exportCSV();" class="p-mr-2" pTooltip="CSV" tooltipPosition="bottom"></button> -->
                        <p-tableHeaderCheckbox style="float: right;margin-right:3px" class="checkbox"></p-tableHeaderCheckbox>
                    </th>
                    
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-recipe let-columns="columns" let-index="rowIndex">
                <tr [pReorderableRow]="index" [pSelectableRow]="recipe">
                    <td pEditableColumn>
                        <span class="pi pi-bars" [pReorderableRowHandle]="index"></span>
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="recipe.position" required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                {{recipe.position}} {{index}}
                            </ng-template>
                        </p-cellEditor>
                        <!-- <p-tableCheckbox [value]="recipe"></p-tableCheckbox> -->
                    </td>

                    <td pEditableColumn [class]="includesCol('name') ? 'd' : 'h'">
                        <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="recipe.name" required>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{recipe.name}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>
<!-- onEditInit= onEditComplete onEditCancel
                    (blur)="save({ data: item })"
                                 (keydown.tab)="save({ data: item })"
                                 (keydown.enter)="save({ data: item })" -->
                    <td pEditableColumn [class]="includesCol('description') ? 'd' : 'h'" >
                        <p-cellEditor >
                            <ng-template pTemplate="input" >
                                <input pInputText type="text" [(ngModel)]="recipe.description"  (blur)="completeRecipe(recipe)" (keydown.tab)="completeRecipe(recipe)" (keydown.enter)="completeRecipe(recipe)"  required>
                            </ng-template>
                            <ng-template pTemplate="output">
                                <span >{{recipe.description}}</span>
                            </ng-template>
                        </p-cellEditor>
                    </td>

                    <td pEditableColumn [class]="includesCol('inputs') ? 'd' : 'h'">
                        <!-- <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="recipe.inputItems" required>
                            </ng-template>
                            <ng-template pTemplate="output" >
                                <span >{{recipe.inputItems}}</span>
                            </ng-template>
                        </p-cellEditor> -->
                        <ul style="list-style: none">
                            <!-- // https://firebase.blog/posts/2014/04/best-practices-arrays-in-firebase -->
                            <li *ngFor="let it of recipe.inputItems |keyvalue ; let i = index">
                             <i> {{ display(it.value, 'quantity') }}</i> &nbsp;units of <b>{{ display(it.value, 'name') }}</b>
                          </li>    
                         </ul>
                    </td>

                    <td pEditableColumn [class]="includesCol('outputs') ? 'd' : 'h'">
                        <!-- <p-cellEditor>
                            <ng-template pTemplate="input">
                                <input pInputText type="text" [(ngModel)]="recipe.outputItems" required>
                            </ng-template>
                            <ng-template pTemplate="output" > -->
                                <!-- <span >{{recipe.outputItems}} {{ it.key }} </span> -->
                                <ul style="list-style: none">
                                   <!-- // https://firebase.blog/posts/2014/04/best-practices-arrays-in-firebase -->
                                   <li *ngFor="let it of recipe.outputItems |keyvalue ; let i = index">
                                    {{ display(it.value, 'name') }}
                                 </li>    
                                </ul>
                            <!-- </ng-template>
                        </p-cellEditor> -->
                    </td>


                    <!-- <td>{{recipe.name}}</td> -->
                    <!-- <td>nicolas</td> -->
                    <!-- <td><img [src]="'assets/showcase/images/demo/product/' + product.image" [alt]="product.name" width="100" class="p-shadow-4" /></td> -->
                    <!-- <td>{{product.price | currency:'USD'}}</td>
                    <td>{{product.category}}</td>
                    <td><p-rating [ngModel]="product.rating" [readonly]="true" [cancel]="false"></p-rating></td>
                    <td><span [class]="'product-badge status-' + (product.inventoryStatus ? product.inventoryStatus.toLowerCase() : '')">{{product.inventoryStatus}}</span></td> -->
                    <td class="row-actions">
                        <button style="margin-right: 10px" pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editRecipe(recipe)"></button>
                        <button style="margin-right: 10px" pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteRecipe(recipe)"></button>
                        <p-tableCheckbox class="checkbox" [value]="recipe"></p-tableCheckbox>
                        
                    </td>
                    <!-- <td>
                        <p-tableCheckbox [value]="recipe"></p-tableCheckbox>
                    </td> -->
                </tr>
            </ng-template>
            <ng-template pTemplate="summary">
                <div class="summary">
                    <div class="summary-total">
                        Total: {{recipes ? recipes.length : 0 }} recipes.
                    </div>
                    <div class="summary-export">
                        <button style="margin-right: 10px"type="button" pButton pRipple icon="pi pi-file-o" (click)="exportToCsv()" class="p-mr-2" pTooltip="CSV" tooltipPosition="bottom"></button>
                        <button style="margin-right: 10px"type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()" class="p-button-success p-mr-2"  pTooltip="XLS" tooltipPosition="bottom"></button>
                        <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()" class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
                    </div>
                </div>
            </ng-template>
        </p-table>

    </div>

    <div class="page-footer">
       
        <div class="p-d-flex">
            <!-- <button type="button" pButton pRipple icon="pi pi-filter" (click)="dt.exportCSV({selectionOnly:true})" class="p-button-info p-ml-auto" pTooltip="Selection Only" tooltipPosition="bottom"></button> -->
        </div>
            
    </div>
    
    <p-dialog [(visible)]="recipeDialog" [style]="{width: '650px', height: '650px'}" header="New Recipe" [modal]="true" styleClass="p-fluid" [baseZIndex]='1000'>
            <div class="p-field">
                <label for="title">Name</label>
                <input style="margin-top: 10px;" type="text" pInputText id="name" [(ngModel)]="recipe.name" required autofocus />
                <small class="p-error" *ngIf="submitted && !recipe.name">Recipe name is required.</small>
            </div>
            <br/>
            <div class="p-field">
                <label for="description">Description</label>
                <textarea style="margin-top: 10px;" id="description" pInputTextarea [(ngModel)]="recipe.description" rows="3" cols="20"></textarea>
            </div>
            <br/>
            <!-- <span style="margin-bottom: 10px;;">Recipe items</span> -->
            <app-recipe-items style="margin-top: 10px;" [isPreTable]="false" [isPostTable]="false" tableTitle="Recipe (inputs)" (itemsEmitter)="refreshInputs($event, recipe)"></app-recipe-items>
            <app-recipe-items style="margin-top: 10px;" [isPreTable]="false" [isPostTable]="false" tableTitle="Recipe (outputs)" (itemsEmitter)="refreshOutputs($event, recipe)"></app-recipe-items>
            <div class="in-out" style="margin-top: 20px;">
                <button pButton pRipple label="Cancel" icon="pi pi-times" class="button-action p-button-danger p-mr-2" (click)="hideDialog()"></button>
                <button pButton pRipple label="Save" icon="pi pi-check" class="button-action p-button-success p-mr-2" (click)="saveRecipe()"></button>
            </div>
    </p-dialog>
    
    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

</div>






